import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment-timezone";
import { fetchReservations, postReservationAccept, tablesToChange as fetchTablesToChange, changeTables, getReservationSums, fetchTables, fetchConnectTablesConfig, fetchAllReservations, resetAttendance, fetchLastReservationsWithChatMessages, fetchFilters } from "../actions/restaurantActions";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { FiCopy } from "react-icons/fi";
import { toast } from "react-toastify";
import { fetchZones, fetchReservationBlockedWeekdays, checkCancelAction, updateReservation, postPhoneOrEmailConfirmation, getRestaurantTimeZone } from "../actions/reservationsActions";
import ReservationHistory from "../components/ReservationHistory";
import Loader from "../components/Loader";
import Messages from "../components/Messages";
import SwitchLabelButton from "../components/SwitchLabelButton";
import UsePrevious from "../components/UsePrevious";
import TablesModal from "../components/ChangeTables";
import WaitCheckMark from "../components/WaitCheckMark";
import AttendanceButtons from "../components/AttendanceButtons";
import NotificationBell from "../components/NotificationBell";
import CustomDatePickerReservationSums from "../components/CustomDatePickerReservationSums";
import ReservationScreen from "./ReservationScreen";
import FiltersComponent from "../components/FiltersComponent";
import ReservationChat from "../components/ReservationChat";
import styled from "styled-components";
import CustomSelect from "../components/SelectableCustom";
import CustomSelectArray from "../components/CustomSelectArray";
import CustomSelectArrayOfObjects from "../components/CustomSelectArrayOfObjects";
import { Row, Col, Card, Modal, Table, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DateTime } from "luxon";
import { faList, faExclamationTriangle, faPlus, faCalendar, faFilter, faSun, faMap, faCircleDot, faStopwatch, faChair, faUsers, faCircleXmark, faFilePen, faRectangleXmark, faEnvelope, faWheelchairMove, faBaby, faBell, faReply, faSearch, faSquareCheck, faEye, faPhone, faCircleCheck, faGear, faXmark, faCheck, faPhoneSlash, faLock, faChartColumn, faRefresh } from "@fortawesome/free-solid-svg-icons";
import Separator from "../components/Separator";
import LoaderComponent from "../components/LoaderComponent";
import ReservationStatusBox from "../components/ReservationStatusBox";
import CompareChanges from "../components/CompareChanges";
import ShowCustomerInfo from "../components/ShowCustomerInfo";
import { TableIconSvg } from "../icons/SvgIcons";
import { CalendarSvgIcon, FilterSvgIcon, GearSvgIcon, NoPhoneSvgIcon, OnOffSvgIcon, PhoneSvgIcon, PlusSvgIcon, ReservationSvgIcon, TableSvgIcon, UsersSvgIcon, XSvgIcon, UserSvgIcon, ClockSvgIcon, BellSvgIcon, BubbleTextSvgIcon, ZoneSvgIcon, PennotebookSvgIcon, ExtrasSvgIcon, ArrowUpDownIcon, ArrowUpDown, NoPhoneTwoLinesSvgIcon } from "../icons/SvgIcons";
import DropDownButton from "../components/DropDownButton";
import ReservationCard from "../components/ReservationCard";
import { DefaultDate, CloseIcon, CardHeader, CardHeaderTitle, statusGroups } from "../components/DefaultImports";
import { CustomModal, ModernButton } from "../components/CustomModal";
import SelectableStatusOptions from "../components/inputs/SelectableStatusOptions";
import { ConfirmationModal } from "../components/ConfirmationModal";
import { createReservationSlice } from "../reducers/reservationReducers";
import DropdownSortItems from "../components/inputs/DropdownSortItems";
import { useOnlineStatus } from "../components/ConectionStatus";
import ReservationStatusChanger from "../components/Reservations/ReservationStatusChanger";
import ScreenNoConectionError from "../components/ScreenNoConectionError";
import DailyFloorBoard from "../place_design/DailyFloorBoard";
import IconColorVariationButton, { getInitialIconColorVariation } from "../components/IconColorVariationButton";
const ReservationViewContent = styled.div`
  width: 100%;
  min-height: 0;
`;
const FloorBoardContainer = styled.div`
  height: ${({
  height
}) => `${height}px`};
  overflow: hidden;
  padding: 0;
  border: none;
  background: transparent;
`;
const ReservationViewSwitcher = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  margin: 8px 0 12px 0;
`;
const ReservationViewButton = styled.button`
  width: 38px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid ${({
  active
}) => active ? "#EE754C" : "#ddd"};
  background: ${({
  active
}) => active ? "#fff1e8" : "#fff"};
  color: ${({
  active
}) => active ? "#EE754C" : "#4B3335"};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #ee754c;
    background: #fff7f2;
  }
`;
const Container = styled.div`
  width: 100%;
  min-height: 100%;
  margin: 0;
  padding: 12px 12px 0 12px;

  @media (max-width: 768px) {
    padding: 8px;
    padding-top: 0;
    margin: 0;
  }
`;
const ContentCenter = styled.div`
  width: 100%;
  max-width: ${({
  $floorMode
}) => $floorMode ? "100%" : "1200px"};
  margin: ${({
  $floorMode
}) => $floorMode ? "0" : "0 auto"};
`;
const PageTitleBar = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  padding: 6px 0 10px 0;
  border-bottom: 1px solid #eadfd5;
`;
const PageTitleText = styled.div`
  font-size: 1.45rem;
  font-weight: 850;
  color: #ee754c;
  letter-spacing: -0.02em;
`;
const PageTitleActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const HeaderCreateReservationButton = styled.button`
  height: 34px;
  border-radius: 9px;
  border: 1px solid #ee754c;
  background: #ee754c;
  color: white;
  padding: 0 12px;
  font-size: 0.85rem;
  font-weight: 800;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  transition: all 0.15s ease;

  @media (min-width: 769px) {
    margin-right: ${({
  $is_production
}) => $is_production ? "100px" : "0px"};
  }

  &:hover {
    background: #d8643d;
    border-color: #d8643d;
  }
`;
const HeaderViewSwitcher = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  @media (min-width: 769px) {
    padding-right: 100px;
  }
`;
const ReservationContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  padding-right: 2px;
  padding-bottom: 0;
  overflow-y: auto;
  overflow-x: hidden;

  scrollbar-width: thin;
  scrollbar-color: rgba(153, 176, 173, 0.38) transparent;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(153, 176, 173, 0.38);
    border-radius: 999px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: rgba(153, 176, 173, 0.65);
  }

  &::-webkit-scrollbar-button {
    display: none;
    width: 0;
    height: 0;
  }
`;
const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
`;
const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  gap: 20px;
  margin-bottom: 1rem;
`;
const FilterItem = styled.div`
  margin: 0px;
`;
const FilterLabel = styled.label`
  display: block;
  margin: 0;
  font-size: 1.1rem;
`;
const FilterInput = styled.input`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const FilterSelect = styled.select`
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;
const ReservationGrid = styled.div`
  display: grid;
`;
const ReservationTop = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 35px;
  background-color: #99b0ad;
  color: #faf6e9;
`;
const ReservationBot = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  height: auto;
`;
const ReservationBotItems = styled.div`
  display: flex;
  margin: 5px;
  font-size: 18px;
`;
const ReservationBotItemss = styled.div`
  display: flex;
  margin: 4px;
`;
const ReservationBoxWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 5px;
  margin: 0;
  width: 100%;
`;
const ReservationBotItemsContainer = styled.div`
  display: flex;
  width: 100%;
`;
const ReservationFlexEnd = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  padding-right: 5px;
`;
const ReservationTitle = styled.h2`
  display: flex;
  font-size: 1rem;
  color: #faf6e9;
  margin-top: 4px;
  margin-left: 5px;
`;
const ReservationDate = styled.h2`
  font-size: 1rem;
  color: white;
  margin-top: 0px;
  margin-left: 5px;
`;
const AttendanceButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  width: auto;
  height: auto;
`;
const FirstWarningMessage = styled.div`
  display: flex;
  gap: 10px;
  position: absolute;
  top: 0.2rem;
  right: 4rem;
  color: #d15823;
`;
const ReservationInfo = styled.p`
  margin-bottom: 1rem;
`;
const ActionButtons = styled.div`
  display: flex;
  justify-content: space-between;
`;
const Button = styled.button`
  display: inline-block;
  font-weight: 400;
  color: #fff;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  background-color: #007bff;
  border: 1px solid #007bff;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 4px;

  &:hover {
    background-color: #0069d9;
    border-color: #0062cc;
  }
`;
const SuccessButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #a5d9d7;
  border: 1px solid #e8e6e6;
  width: 50%;
  height: 100%;
  padding: 0;
  margin: 0;
  border-radius: 0;
`;
const DangerButton = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #a5d9d7;
  border-radius: 0;
  border: 1px solid #e8e6e6;
  padding: 0;
  width: 50%;
  height: 100%;
  margin: 0;
`;
const EditButton = styled(Button)`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #59d9d4;
  border: 0;
  top: 0;
  left: 0;
  height: 28px;
  width: 100%;
  padding: 0;
  margin: 0;
  border-radius: 0;

  &:hover {
    background-color: #228a86;
  }
`;
const StyledIcon = styled(FontAwesomeIcon)`
  margin: 0;
  padding: 0;
  font-size: 28px;
`;
const SuccessButtonFilter = styled(Button)`
  width: 100px;
  background-color: #00b33c;
  border-color: #00b33c;

  &:hover {
    background-color: #80ffaa;
    border-color: #80ffaa;
  }
`;
const DateFilterContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: start;
  margin-bottom: 1rem;
`;
const OtherFiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
const DateButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0;
  height: 32px;
  border-radius: 5px;
  border: 0px solid gray;
  width: auto;
  overflow: hidden;
  margin-bottom: 5px;
`;
const DateButtonLeft = styled.div`
  padding: 0;
  background-color: #99b0ad;
  height: 100%;
  width: 30px;
  text-align: center;
  border-right: 0px solid gray;
  cursor: pointer;
`;
const DateButtonRight = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: gray;
  background-color: white;
  text-align: center;
  width: auto;
  cursor: pointer;
  padding: 5px;
  border-right: 0px solid gray;
  border-radius: 0 5px 5px 0;
`;
const WeekDayRight = styled.div`
  display: flex;
  background-color: white;
  align-items: center;
  font-size: 12px;
  color: gray;
  text-align: center;
  width: 35px;
  cursor: pointer;
  padding-left: 5px;
`;
const FilterButton = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0;
  margin: 0;
  height: auto;
  border-radius: 5px;
  border: 0x solid gray;
  width: 100%;
  overflow: hidden;
`;
const FilterButtonLeft = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #99b0ad;
  height: auto;
  width: 30px;
  border-right: 0px solid gray;
  cursor: pointer;
  align-items: center;
`;
const FilterButtonRight = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: gray;
  background-color: white;
  text-align: start;
  width: 100%;
  height: 100%;
  cursor: pointer;
  padding: 0;
  margin: 0;
  overflow-x: auto;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f4f4f4;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8;
  }

  -ms-overflow-style: auto;
`;
const StyledCard = styled(Card)`
  margin: ${({
  $floorMode
}) => $floorMode ? "0 0 8px 0" : "10px 0"};
  box-shadow: ${({
  $floorMode
}) => $floorMode ? "none" : "0px 4px 8px 0px rgba(0, 0, 0, 0.2)"};
  border-radius: ${({
  $floorMode
}) => $floorMode ? "0" : "5px"};
  border: ${({
  $floorMode
}) => $floorMode ? "none" : "0"};
  background: ${({
  $floorMode
}) => $floorMode ? "transparent" : "#fff"};
`;
const CardTop = styled.div`
  padding: ${({
  $floorMode
}) => $floorMode ? "4px 0 8px 0" : "10px"};
  min-height: ${({
  $floorMode
}) => $floorMode ? "auto" : "50px"};
  background-color: ${({
  $floorMode
}) => $floorMode ? "transparent" : "#faf6e9"};
  justify-content: center;
`;
const CardBottom = styled.div`
  padding: 5px;
  background-color: #8febc5;
`;
const CreateZoneButton = styled(ModernButton)`
  position: absolute;
  display: flex;
  top: 10px;
  right: 11px;
  background-color: #99b0ad;

  &:hover {
    background-color: #bbbbbb;
  }
`;
const CreateZoneButtonWaitingList = styled(ModernButton)`
  position: absolute;
  display: flex;
  top: 45px;
  right: 11px;
  background-color: #59d9d4;

  &:hover {
    background-color: #228a86;
  }
`;
const LargeIconPlus = styled(FontAwesomeIcon)`
  margin-left: 7px;
  color: #faf6e9;
`;
const CancelIcon = styled(FontAwesomeIcon)`
  top: 3px;
  right: 3px;
  position: absolute;
  --fa-primary-color: #d35612;
  --fa-secondary-color: #ffffff;
`;
const TableBox = styled.div`
  display: inline-block;
  margin: 2px;
  width: auto;
  height: 25px;
  padding-left: 3px;
  padding-right: 3px;
  line-height: 25px;
  text-align: center;
  background-color: #3ecf95;
  color: white;
  border: 1px solid gray;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  box-sizing: border-box;
`;
const ModalBackgroundToCustomDate = styled.div`
  position: fixed;
  z-index: 110;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;
const CustomDateContainer = styled.div`
  position: fixed;
  width: auto;
  height: auto;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  z-index: 120;
`;
const StyledH7 = styled.div`
  font-size: 15px;
  color: #faf6e9;
`;
const SearchIcon = styled(FontAwesomeIcon)`
  position: absolute;
  right: 5px;
  top: 5px;
`;
const SearchBarLeft = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #99b0ad;
  width: 30px;
  border-right: 0px solid gray;
  cursor: pointer;
  align-items: center;
  height: 30px;
  margin-top: 5px;
  border-radius: 5px 0px 0px 5px;
`;
const SearchBar = styled.div`
  margin-top: 5px;
  position: relative;
  width: 100%;
  height: 30px !important;
  border-radius: 8px;
  transition: box-shadow 0.2s ease;
`;
const SearchInput = styled.input`
  font-size: 14px;
  border-radius: 0px 5px 5px 0px;
  border: none;
  padding-left: 6px;
  height: 30px;
  width: 100%;
  outline: none;
  color: #99b0ad;

  box-shadow: ${props => props.active ? "inset 0 0 0 1px rgba(238, 117, 76, 0.7)" : "none"};

  &:focus {
    border: none;
    outline: none;
    box-shadow: none;
    color: #99b0ad;
  }
`;
const SuggestionBox = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 10;
  background: white;
  border-top: none;
  width: 100%;
  color: #99b0ad;
  max-height: 120px;
  overflow-y: auto;
  border-radius: 0 0 5px 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
const SuggestionItem = styled.div`
  padding: 6px 10px;
  font-size: 0.8rem;
  cursor: pointer;
  color: #99b0ad;

  &:hover {
    background-color: #f1f1f1;
  }
`;
const FormCheck = styled.div`
  margin-left: 5px;
  margin-right: 5px;
  padding-bottom: 3px;
`;
const StyledCheckbox = styled.input.attrs({
  type: "checkbox"
})`
  &.makeItGreen:checked {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3E%3Cpath fill='%2300A400' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 75%;
  }
`;
const FilterBoxes = styled.div`
  display: flex;
  white-space: nowrap;
  align-items: center;
  font-size: 10px;
  justify-content: center;
  min-width: 50px;
  height: 18px;
  border-radius: 4px;
  border: 1px solid black;
  padding: 3px;
  margin: 2px 1px 2px 1px;
  color: #ffffff;
  overflow: hidden;
  background-color: ${props => props.backgroundColor !== null ? props.backgroundColor : "#ffffff"};
`;
const TablesUsedSeatSums = styled.div`
  color: ${props => props.reservation_number > props.total_number_of_seats ? "red" : "#5ace8c"};
`;
const CustomRow = styled.div`
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  height: auto;
  align-items: center;
  display: flex;
`;
const SelectableStatusCol = styled(Col)`
  display: flex;
  flex-wrap: nowrap;
  margin-top: 6px;
  justify-content: end;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    justify-content: start;
    padding-left: 4px;
    padding-top: 5px;
  }
`;
const TimeColStyled = styled(Col)`
  display: flex;
  flex-wrap: nowrap;
  padding-bottom: 10px;
  padding-top: 10px;

  @media (max-width: 768px) {
    padding-bottom: 4px;
    padding-top: 2px;
  }
`;

/* LIST VIEW FILTERS — restored closer to old card style */

const FiltersBlockShell = styled.div`
  width: 100%;
  margin: 10px 0;
  padding: 5px;
  min-height: 50px;
  position: relative;
  background-color: #faf6e9;
  border-radius: 5px;
  border: 0;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.2);
`;
const PlanLockedFilters = styled.div`
  position: relative;
  width: 100%;
  border-radius: 5px;
  opacity: ${({
  $locked
}) => $locked ? 0.65 : 1};
  cursor: ${({
  $locked
}) => $locked ? "not-allowed" : "default"};

  ${({
  $locked
}) => $locked && `
      &::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 20;
        border: 1px solid rgba(133, 133, 133, 0.35);
        border-radius: 5px;
        background: rgba(255, 255, 255, 0.08);
        pointer-events: none;
      }
    `}
`;
const LockedControlOverlay = styled.button`
  position: absolute;
  inset: 0;
  z-index: 50;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 1px solid rgba(133, 133, 133, 0.35);
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.08);
  cursor: not-allowed;
`;
const LockedControlContent = styled.div`
  width: 100%;
  height: 100%;
  pointer-events: ${({
  $locked
}) => $locked ? "none" : "auto"};
`;
const PlanLockedControl = ({
  locked,
  onLockedClick,
  label,
  children
}) => <PlanLockedFilters $locked={locked}>
    {locked && <LockedControlOverlay type="button" onClick={onLockedClick} aria-label={label} />}
    <LockedControlContent $locked={locked}>{children}</LockedControlContent>
  </PlanLockedFilters>;
const FiltersHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 2px;
`;
const FiltersTitle = styled.div`
  display: none;
`;
const FiltersHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  min-height: 34px;
`;
const FiltersStatusBlock = styled.div`
  width: 100%;
  min-width: 0;
  background: transparent;
  border-radius: 5px;
  padding: 0;
  margin: 0;
`;
const IconColorButtonTopRight = styled.div`
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 5;
`;
const FiltersMainRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 430px);
  gap: 8px;
  align-items: start;
  width: 100%;
  margin-bottom: 4px;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;
const FiltersControlsColumn = styled.div`
  width: 100%;
  min-width: 0;
`;
const FilterControlLine = styled.div`
  cursor: pointer;
  display: flex;
  padding: 0;
  margin: 0 0 4px 0;
  height: auto;
  border-radius: 5px;
  border: 0px solid gray;
  width: 100%;
  overflow: visible;
  background: transparent;
`;
const FilterControlIcon = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #99b0ad;
  min-height: 32px;
  width: 30px;
  min-width: 30px;
  border-right: 0px solid gray;
  cursor: pointer;
  align-items: center;
  border-radius: 5px 0 0 5px;
`;
const FilterControlContent = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: gray;
  background-color: white;
  text-align: start;
  width: 100%;
  min-width: 0;
  min-height: 32px;
  cursor: pointer;
  padding: 0 6px;
  margin: 0;
  overflow-x: auto;
  border-radius: 0 5px 5px 0;

  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: #f4f4f4;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #bdbdbd;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #a8a8a8;
  }

  -ms-overflow-style: auto;
`;
const FilterSearchSortRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 130px;
  gap: 4px;
  width: 100%;
  align-items: center;
  margin-top: 2px;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr) 108px;
    gap: 4px;
  }

  @media (max-width: 380px) {
    grid-template-columns: minmax(0, 1fr) 98px;
    gap: 3px;
  }
`;
const SearchInline = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;

  ${SearchBarLeft} {
    margin-top: 0;
  }

  ${SearchBar} {
    margin-top: 0;
  }
`;

/* FLOOR VIEW FILTERS — keep new compact style */

const FloorFiltersBlockShell = styled.div`
  width: 100%;
  background: #ffffff;
  border: none;
  border-radius: 0;
  padding: 0;
  margin: 0;
  position: sticky;
  top: 0;
  z-index: 5;
`;
const FloorFiltersHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  margin: 0;
  padding: 0 0 4px 0;
`;
const FloorFiltersTitle = styled.div`
  font-size: 1.2rem;
  font-weight: 850;
  color: #ee754c;
  letter-spacing: -0.01em;
`;
const FloorFiltersHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;
const FloorFiltersStatusBlock = styled.div`
  width: 100%;
  position: relative;
  z-index: 4;
  background: transparent;
  border-radius: 0;
  margin: 0 0 4px 0;
  padding: 0;
`;
const FloorFilterControlLine = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  background: transparent;
  border-radius: 0;
  overflow: visible;
  margin: 0 0 4px 0;
  border: none;
`;
const FloorFilterControlIcon = styled.div`
  width: 28px;
  min-width: 28px;
  min-height: 30px;
  background-color: #99b0ad;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0;
`;
const FloorFilterControlContent = styled.div`
  flex: 1;
  min-width: 0;
  min-height: 30px;
  padding: 0 4px;
  display: flex;
  align-items: center;
  background: #ffffff;
  border-radius: 0;
`;
const FloorFilterSearchSortRow = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 118px;
  gap: 4px;
  width: 100%;
  align-items: center;
  margin: 0;
  padding: 0;

  @media (max-width: 768px) {
    grid-template-columns: minmax(0, 1fr) 108px;
    gap: 4px;
  }

  @media (max-width: 380px) {
    grid-template-columns: minmax(0, 1fr) 98px;
    gap: 3px;
  }
`;
const FloorSearchInline = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
`;
const FloorSearchBarLeft = styled.div`
  display: flex;
  justify-content: center;
  padding: 0;
  margin: 0;
  background-color: #99b0ad;
  width: 28px;
  min-width: 28px;
  border-right: 0;
  cursor: pointer;
  align-items: center;
  height: 30px;
  border-radius: 0;
`;
const FloorSearchBar = styled.div`
  position: relative;
  width: 100%;
  height: 30px !important;
  border-radius: 0;
  transition: box-shadow 0.2s ease;
`;
const FloorCreateReservationButton = styled(ModernButton)`
  position: static;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #99b0ad;
  height: 32px;
  padding: 0 10px;

  &:hover {
    background-color: #bbbbbb;
  }
`;
function getTableInfo(selectedTablesList, allTablesList) {
  let tableInfo = {};
  Object.keys(selectedTablesList).forEach(zoneName => {
    const tableNumbers = selectedTablesList[zoneName].map(table => table.number);
    allTablesList.forEach(tablesInZone => {
      if (tablesInZone[0] === zoneName) {
        tableNumbers.forEach(tableNumber => {
          const tableDetails = tablesInZone.find(table => table.split(";")[0] === tableNumber);
          if (tableDetails) {
            if (tableInfo[zoneName]) {
              tableInfo[zoneName].push(tableDetails);
            } else {
              tableInfo[zoneName] = [tableDetails];
            }
          }
        });
      }
    });
  });

  // Convert the object into a list of lists
  let tableInfoList = [];
  Object.keys(tableInfo).forEach(zone => {
    tableInfoList.push([zone, ...tableInfo[zone]]);
  });
  return tableInfoList;
}
function listToSelectedTablesFormat(zoneName, tableNumbers) {
  if (!Array.isArray(tableNumbers)) {
    throw new Error("Expected parameter to be an array");
  }
  const tables = tableNumbers.map(tableNumber => ({
    number: tableNumber,
    status: "0"
  }));
  return {
    [zoneName]: tables
  };
}
function ReservationFromRestaurantScreen() {
  const {
    t
  } = useTranslation();
  const is_production = process.env.REACT_APP_IS_PRODUCTION === "false" ? false : true;
  const reservationsFromRestaurant = useSelector(state => state.reservationsFromRestaurant);
  const onlineStatus = useOnlineStatus();
  const {
    reservations,
    isLoading = false,
    error,
    allReservations,
    lastReservationsWithChatMessages
  } = reservationsFromRestaurant;
  const tablesChangeds = useSelector(state => state.changedTables);
  const {
    tablesChanged = [],
    isLoadingChangeTables
  } = tablesChangeds;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = useParams();
  const today = new Date();
  const lastManualUpdate = useRef(null);
  const formattedToday = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  const [dateFilter, setDateFilter] = useState(formattedToday);
  const [placeFilter, setPlaceFilter] = useState("");
  const [data, setData] = useState(null);
  const prevData = UsePrevious(data);
  const [statusFilter, setStatusFilter] = useState(id.status === "all_pending_reservations" ? id.status : "Todos");
  const [showModal, setShowModal] = useState(false);
  const [tokens, setTokens] = useState("");
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showDateModal, setShowDateModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showFiltersUpgradeModal, setShowFiltersUpgradeModal] = useState(false);
  const [showSortingUpgradeModal, setShowSortingUpgradeModal] = useState(false);
  const [showSearchUpgradeModal, setShowSearchUpgradeModal] = useState(false);
  const [areReservationFiltersBlocked, setAreReservationFiltersBlocked] = useState(true);
  const [isReservationModalOpen, setIsReservationModalOpen] = useState(false);
  const [isCreatingReservation, setIsCreatingReservation] = useState(false);
  const [reset, setReset] = useState(false);
  const [isAllReservations, setIsAllReservations] = useState(false);
  const [theReservations, setTheReservations] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState("");
  const [reservationViewMode, setReservationViewMode] = useState("cards");

  /*   const [reservationViewMode, setReservationViewMode] = useState(() => {
    try {
      const saved = window.localStorage.getItem("soup_reservation_view_mode");
      if (saved === "cards" || saved === "floor") return saved;
    } catch (e) {
      // ignore localStorage errors
    }
      return "cards";
  }); */

  const [isOpenTimeFilters, setIsOpenTimeFilters] = useState(false);
  const [reservationsWithChatMessages, setReservationsWithChatMessages] = useState([]);
  const [customer_name, setCustomer_name] = useState("");
  const [reservationTokenToPhoneLink, setReservationTokenToPhoneLink] = useState("");
  const [selectedReservation, setSelectedReservation] = useState(null);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [updatedZones, setZonesWithAll] = useState("");
  const [tokena, setTokena] = useState("");
  const [tablesList, setTablesList] = useState("");
  const [isWaiting, setIsWaiting] = useState(false);
  const [acceptMultipleReservations, setAcceptMultipleReservations] = useState(false);
  const [canceltMultipleReservations, setCanceltMultipleReservations] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedMultipleReservations, setSelectedMultipleReservations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [activateLoader, setActivateLoader] = useState(false);
  const [sortedResults, setSortedResults] = useState([]);
  const [sortedResultsAllStatus, setSortedResultsAllStatus] = useState([]);
  const [all_reservations, setAll_reservations] = useState([]);
  const [showNoTablesMessage, setShowNoTablesMessage] = useState(false);
  const [dropDownFilterButton, setDropDownFilterButton] = useState("Horário");
  const [reservationErrorModal, setReservationErrorModal] = useState(false);
  const [reservationSuccessModal, setReservationSuccessModal] = useState(false);
  const [reservationRetry, setReservationRetry] = useState(false);
  const [atTheDoorReservations, setAtTheDoorReservations] = useState(false);
  const [reservations_past_estimated_time, setReservations_past_estimated_time] = useState([]);
  const [showModalInternetConectionFailure, setShowModalInternetConectionFailure] = useState(false);
  const [hasSelectedSuggestion, setHasSelectedSuggestion] = useState(false);
  const [isSugestionActive, setIsSugestionActive] = useState(false);
  const searchRef = useRef(null);
  const [reservationHasBeenModified, setReservationHasBeenModified] = useState(false);
  const [modalReservationModifyReservation, setModalReservationModifyReservation] = useState(false);
  const [isShowCustomerInfoModalActive, setIsShowCustomerInfoModalActive] = useState(false);
  const [reservation_or_waiting_list, setReservation_or_waiting_list] = useState("reservation");
  const reservation_or_waiting_list_options = ["reservation", "waiting_list"];
  const [selectedStatus, setSelectedStatus] = useState(["A CHEGAR", "ATRASADA", "À PORTA", "REST", "CLIENTE", "ESPERA", "FINALIZADA", "CANCELADAS", "Mesa livre"]);
  const [showPhoneModal, setShowPhoneModal] = useState(false);
  const [phoneIsConfirmed, setPhoneIsConfirmed] = useState(false);
  const [completePhone, setCompletePhone] = useState("");
  const [current_reservation_id, setCurrent_reservation_id] = useState("");
  const [reservationLayoutSocketUpdate, setReservationLayoutSocketUpdate] = useState(null);
  const isFloorView = reservationViewMode === "floor";
  const [selectedIconColorVariation, setSelectedIconColorVariation] = useState(getInitialIconColorVariation);

  // ------------------- selectors

  const reservationAccept = useSelector(state => state.reservationAccept);
  const {
    messageAccept,
    isLoadingAccept
  } = reservationAccept;
  const reservationCancel = useSelector(state => state.cancelReservation);
  const {
    cancelMessage,
    isLoadingCancel
  } = reservationCancel;
  const reservationZone = useSelector(state => state.reservationZone);
  const {
    zones,
    isZonesLoading,
    zonesError
  } = reservationZone;
  const customerAttendUpdates = useSelector(state => state.customerAttendUpdate);
  const {
    isLoadingChangeTableNumber
  } = customerAttendUpdates;
  const restaurant_info = useSelector(state => state.restaurantDetails);
  const {
    restaurants
  } = restaurant_info;
  useEffect(() => {
    setAreReservationFiltersBlocked(Number(restaurants?.sub_lvl) === 1 || !restaurants || Number(restaurants?.sub_lvl) === 0);
  }, [restaurants]);
  const handleLockedFiltersClick = event => {
    if (!areReservationFiltersBlocked) return;
    event.preventDefault();
    event.stopPropagation();
    setShowFiltersUpgradeModal(true);
  };
  const handleLockedSortingClick = () => {
    if (areReservationFiltersBlocked) {
      setShowSortingUpgradeModal(true);
    }
  };
  const handleLockedSearchClick = () => {
    if (areReservationFiltersBlocked) {
      setShowSearchUpgradeModal(true);
    }
  };
  const reservation_info = useSelector(state => state.reservationCustomersMenu);
  const {
    reservation
  } = reservation_info;
  const restaurantTimeZone = useSelector(state => state.reservationBlockedWeekDays.restaurantTimeZone);
  const reservation_created_selector = useSelector(state => state.createReservation);
  const {
    reservation_created,
    checkCancel,
    isCheckCancelLoading,
    createReservationFailed,
    createReservationSuccess
  } = reservation_created_selector;
  const createdReservationForModal = Array.isArray(reservation_created) ? reservation_created[0] || {} : reservation_created || {};
  const createdReservationWithoutTables = createdReservationForModal?.not_enough_seats === true || createdReservationForModal?.not_enough_seats === 1 || createdReservationForModal?.not_enough_seats === "1" || createdReservationForModal?.not_enough_seats === "true" || !String(createdReservationForModal?.tablesused || "").trim();
  const all_tables = useSelector(state => state.restaurantTables.tables);
  const fetchedFilters = useSelector(state => state.filtersModels.fetchedFilters);
  const tablesToChange = useSelector(state => state.availableTablesToChange);
  const {
    tables = [],
    isLoadingTables,
    errorTables
  } = tablesToChange;
  const connectTables = useSelector(state => state.connectTablesConfig);
  const {
    connectTablesConfig = []
  } = connectTables;
  const manager_info = useSelector(state => state.crudManager);
  const {
    managerInfo
  } = manager_info;
  const {
    createReservationSuccessErrorReset
  } = createReservationSlice.actions;
  const [showTablesModal, setShowTablesModal] = useState(false);
  const [usedTables, setUsedTables] = useState({});
  const [containerHeight, setContainerHeight] = useState(0);
  const containerRef = useRef(null);
  const reservationViewContentRef = useRef(null);
  const topContainerRef = useRef(null);
  const prevRestaurantIdRef = useRef(null);
  const dateFilterRef = useRef(dateFilter);
  const placeFilterRef = useRef(placeFilter);
  const statusFilterRef = useRef(statusFilter);
  const currentRestaurantIdRef = useRef(null);
  useEffect(() => {
    try {
      window.localStorage.setItem("soup_reservation_view_mode", reservationViewMode);
    } catch (e) {
      // ignore localStorage errors
    }
  }, [reservationViewMode]);
  useEffect(() => {
    currentRestaurantIdRef.current = restaurants?.id ?? null;
  }, [restaurants?.id]);
  useEffect(() => {
    dateFilterRef.current = dateFilter;
    placeFilterRef.current = placeFilter;
    statusFilterRef.current = statusFilter;
  }, [dateFilter, statusFilter]);
  useEffect(() => {
    if (createReservationFailed === true) {
      setReservationErrorModal(true);
    } else {
      setReservationErrorModal(false);
    }
    if (createReservationSuccess === true) {
      setReservationSuccessModal(true);
    } else {
      setReservationSuccessModal(false);
    }
  }, [createReservationFailed, createReservationSuccess]);
  useEffect(() => {
    if (error) {
      setShowModalInternetConectionFailure(true);
    } else {
      setShowModalInternetConectionFailure(false);
    }
  }, [error]);
  useEffect(() => {
    const handleClickOutside = event => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setHasSelectedSuggestion(true); // This hides the suggestions
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (!sortedResults?.length || !restaurants?.timezone) {
      setReservations_past_estimated_time([]);
      return;
    }
    const tz = restaurants.timezone;
    const now = DateTime.now().setZone(tz);
    const pastEstimated = sortedResults.filter(r => {
      const estRaw = r?.estimatedtime; // ✅ correct field
      if (!estRaw) return false;
      const estStr = String(estRaw).trim();

      // If it's an ISO datetime already (has "T"), just parse it
      if (estStr.includes("T")) {
        const est = DateTime.fromISO(estStr).setZone(tz);
        return est.isValid && est < now;
      }

      // Otherwise assume it's a time like "HH:mm" or "HH:mm:ss" and combine with r.date
      if (!r?.date) return false;
      const attempt1 = DateTime.fromFormat(`${r.date} ${estStr}`, "yyyy-MM-dd HH:mm", {
        zone: tz
      });
      const est = attempt1.isValid ? attempt1 : DateTime.fromFormat(`${r.date} ${estStr}`, "yyyy-MM-dd HH:mm:ss", {
        zone: tz
      });
      return est.isValid && est < now;
    });
    setReservations_past_estimated_time(pastEstimated);
  }, [reservations, restaurants?.timezone, sortedResults]);
  useEffect(() => {
    if (restaurants && Object.keys(restaurants).length > 0) {
      dispatch(getReservationSums(restaurants.id, dateFilter));
    }
  }, [restaurants, onlineStatus, dateFilter]);
  useEffect(() => {
    if (!restaurants?.id) return; // guard

    let ignore = false;
    (async () => {
      try {
        console.log("useefect fetchReservations: ", restaurants.id);
        await dispatch(fetchReservations(restaurants.id, dateFilter));
        dispatch(fetchTables(restaurants.id));
        dispatch(fetchConnectTablesConfig(restaurants.id));
        if (ignore) return;
        // optional: do something after it resolves
      } catch (err) {
        console.error(err);
      }
    })();
    return () => {
      ignore = true;
    }; // prevent state updates after unmount
  }, [dispatch, restaurants?.id, dateFilter]);
  useEffect(() => {
    console.log("restaurants?.id: ", restaurants?.id);
  }, [restaurants?.id]);
  useEffect(() => {
    if (restaurants && Object.keys(restaurants).length > 0) {
      dispatch(fetchZones(restaurants.id));
    }
  }, [restaurants, dateFilter]);
  useEffect(() => {
    const calculateHeight = () => {
      const topOffset = reservationViewContentRef.current?.getBoundingClientRect().top || 0;
      const nextHeight = Math.max(window.innerHeight - topOffset - 10, 260);
      setContainerHeight(nextHeight);
    };
    calculateHeight();
    window.addEventListener("resize", calculateHeight);
    const observer = new ResizeObserver(calculateHeight);
    if (reservationViewContentRef.current) {
      observer.observe(reservationViewContentRef.current);
    }
    return () => {
      window.removeEventListener("resize", calculateHeight);
      observer.disconnect();
    };
  }, [reservationViewMode, sortedResults?.length, isAllReservations]);
  const dispatch_reservation_wait = async () => {
    const restaurantId = currentRestaurantIdRef.current;
    if (!restaurantId) return;
    try {
      setIsWaiting(true);
      await Promise.all([dispatch(fetchReservations(restaurantId, dateFilterRef.current)), dispatch(fetchLastReservationsWithChatMessages(restaurantId)), dispatch(fetchAllReservations(restaurantId, null, null, null, "all_pending_reservations_from_all_time"))]);
    } finally {
      setIsWaiting(false);
    }
  };
  useEffect(() => {
    setAll_reservations(allReservations);
  }, [allReservations]);
  useEffect(() => {
    if (restaurantTimeZone) {
      setCurrentDateTime(moment.tz(restaurantTimeZone.timezone));
    }
  }, [restaurantTimeZone]);
  useEffect(() => {
    const isAllReservationsEmpty = !Array.isArray(allReservations) || allReservations.length === 0;
    setActivateLoader(isLoading || isLoadingChangeTableNumber);
  }, [allReservations, isLoadingChangeTableNumber, isLoading]);
  useEffect(() => {
    if (restaurantTimeZone) {
      const timer = setInterval(() => {
        setCurrentDateTime(moment.tz(restaurantTimeZone.timezone));
      }, 60000); // 60,000 milliseconds = 1 minute

      // Cleanup: clear the interval when the component is destroyed
      return () => clearInterval(timer);
    }
  }, [restaurantTimeZone]);
  function deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (typeof obj1 !== "object" || obj1 === null || typeof obj2 !== "object" || obj2 === null) {
      return false;
    }
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (keys1.length !== keys2.length) return false;
    for (let key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }
  useEffect(() => {
    if (reservations && allReservations) {
      let isReservationsAll = false;
      let shouldUpdate = false;
      let allTokensPresent = true;
      if (isAllReservations && allReservations.length > 0) {
        isReservationsAll = true;
        // Check if every token in allReservations is present in theReservations
        let allTokensPresent = true;
        if (Array.isArray(theReservations)) {
          allTokensPresent = deepEqual(allReservations, theReservations);
        }
        // Update only if not all tokens are present
        if (!allTokensPresent) {
          shouldUpdate = true;
        }
      } else {
        isReservationsAll = false;
        setIsAllReservations(false);
        // Similar logic could be applied for `reservations` and `theReservations`

        if (Array.isArray(theReservations)) {
          allTokensPresent = deepEqual(reservations, theReservations);
        }
        // Update only if not all tokens are present
        if (!allTokensPresent || reservations.length === 0) {
          shouldUpdate = true;
        }
      }
      if (shouldUpdate) {
        setTheReservations(isReservationsAll ? allReservations : reservations);
        setSelectedMultipleReservations([]);
      }
      const WAITING_LIST_STATUS = "waiting_list";
      // ✅ split waiting list OUT first

      const waiting_list_reservations = reservations.filter(r => r.status === WAITING_LIST_STATUS);
      // ✅ waiting list should show no matter what and NOT be affected by dropdown sorting
      setAtTheDoorReservations(waiting_list_reservations);
    }
  }, [reservations, allReservations, isAllReservations]);
  useEffect(() => {
    if (!theReservations || theReservations.length === 0) {
      setSearchResults(theReservations);
      return;
    }
    const normalizeText = text => {
      if (text === null || text === undefined) return "";
      return String(text).toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/\W+/g, " ").trim();
    };
    const normalizedSearchTerm = normalizeText(searchTerm);
    const searchTokens = normalizedSearchTerm ? normalizedSearchTerm.split(/\s+/) : [];
    const filteredBySearchTerm = theReservations.filter(reservation => {
      const normalizedFullName = normalizeText(reservation.full_name);
      const normalizedPhoneNumber = normalizeText(reservation.phone_number);
      const normalizedTableNumber = normalizeText(reservation.table_number);
      if (searchTokens.length === 0) return true;
      return searchTokens.every(token => {
        return normalizedFullName.includes(token) || normalizedPhoneNumber.includes(token) || normalizedTableNumber.includes(token);
      });
    });
    const filteredByTimeRange = filteredBySearchTerm.filter(reservation => {
      const formatTime = time => {
        if (!time || typeof time !== "string") return "00:00";
        return time.length === 5 ? time : `0${time}`;
      };
      if (!selectedFilters || selectedFilters.length === 0) return false;
      if (selectedFilters.includes("tudo")) return true;
      return selectedFilters.some(filter => {
        if (!filter || typeof filter !== "object") return false;
        return formatTime(reservation.time) >= formatTime(filter.start_time) && formatTime(reservation.time) < formatTime(filter.end_time);
      });
    });
    const filteredByPlace = filteredByTimeRange.filter(r => {
      if (!placeFilter || placeFilter.length === 0) return false;
      const hasSemSala = placeFilter.includes("Sem Sala");
      const placeName = r.table_place_preference?.place_of_table;
      if (!placeName) return hasSemSala;
      return placeFilter.includes(placeName);
    });
    setSearchResults(filteredByPlace);
  }, [searchTerm, theReservations, selectedFilters, placeFilter]);
  useEffect(() => {
    if (!Array.isArray(searchResults) || searchResults.length === 0) {
      setSortedResultsAllStatus([]);
      setSortedResults([]);
      return;
    }
    const sortOrder = {
      Cancelled_By_Customer_Warning: 0,
      late: 1,
      pending_customer: 2,
      pending_restaurant: 3,
      edited: 4,
      waiting_list: 5,
      Accepted_edit: 6,
      Rejected_edition: 6,
      Accepted_Without_Table: 6,
      accepted: 6,
      Accepted_With_Table: 6,
      attended: 8,
      no_show: 9,
      cancelled_customer: 10,
      cancelled_restaurant: 11,
      cancelled: 13
    };
    const sortReservations = reservationsToSort => {
      return [...reservationsToSort].sort((a, b) => {
        const statusOrderDiff = (sortOrder[a.status] ?? 999) - (sortOrder[b.status] ?? 999);
        if (statusOrderDiff !== 0) return statusOrderDiff;
        const isValidTableNumber = tableNumber => {
          if (tableNumber === null || tableNumber === undefined) return 0;
          const tableNumberStr = typeof tableNumber === "string" ? tableNumber : String(tableNumber);
          return tableNumberStr.trim() !== "" && tableNumberStr.trim().toLowerCase() !== "null" ? 1 : 0;
        };
        const aHasTableNumber = isValidTableNumber(a.table_number);
        const bHasTableNumber = isValidTableNumber(b.table_number);
        if (!aHasTableNumber && bHasTableNumber) return -1;
        if (aHasTableNumber && !bHasTableNumber) return 1;
        if (dropDownFilterButton === "Horário") {
          const convertTimeToComparableNumber = timeString => {
            if (!timeString) return 0;
            const [hours, minutes] = String(timeString).split(":");
            return parseInt(hours, 10) * 100 + parseInt(minutes, 10);
          };
          const timeA = convertTimeToComparableNumber(a.time);
          const timeB = convertTimeToComparableNumber(b.time);
          return timeA - timeB;
        }
        if (dropDownFilterButton === "Grupos maiores") {
          return Number(b.number_of_people || 0) - Number(a.number_of_people || 0);
        }
        if (dropDownFilterButton === "Grupos menores") {
          return Number(a.number_of_people || 0) - Number(b.number_of_people || 0);
        }
        if (dropDownFilterButton === "A - Z") {
          return (a.full_name || "").localeCompare(b.full_name || "");
        }
        return 0;
      });
    };
    const validStatuses = (selectedStatus || []).flatMap(category => statusGroups[category] || []);
    setSortedResultsAllStatus(searchResults);
    const filteredResults = validStatuses.length > 0 ? searchResults.filter(reservation => validStatuses.includes(reservation.status)) : [];
    const sorted = sortReservations(filteredResults);
    setSortedResults(sorted);
  }, [searchResults, dropDownFilterButton, selectedStatus]);
  useEffect(() => {
    console.log("------------------start----------------: ");
    if (reservations) {
      console.log("reservations: ", reservations);
    }
    console.log("sortedResults: ", sortedResults);
    console.log("searchResults: ", searchResults);
    console.log("theReservations: ", theReservations);
    console.log("------------------end----------------: ");
  }, [sortedResults]);
  useEffect(() => {
    if (id?.date && id.date !== "null") {
      setDateFilter(id.date);
    }
  }, [id?.date]);
  useEffect(() => {
    setTablesList(reservations);
  }, [reservations]);
  useEffect(() => {
    setReservationsWithChatMessages(lastReservationsWithChatMessages);
  }, [lastReservationsWithChatMessages]);
  useEffect(() => {}, [reservationsWithChatMessages]);
  useEffect(() => {
    if (zones?.zones) {
      setZonesWithAll(() => {
        const updatedZones = zones.zones.slice();
        return ["Sem Sala", ...updatedZones];
      });
    }
  }, [zones]);
  // choose the right filter according to the time
  useEffect(() => {
    if (fetchedFilters) {
      const checkAndSetFilters = () => {
        const currentDate = new Date();
        const currentHours = currentDate.getHours();
        const currentMinutes = currentDate.getMinutes();
        const normalizeTime = timeStr => timeStr === "24:00" ? "23:59" : timeStr;
        const firstMatchingFilter = fetchedFilters.find(filter => {
          const startTime = new Date(`${currentDate.toDateString()} ${normalizeTime(filter.start_time)}`);
          const endTime = new Date(`${currentDate.toDateString()} ${normalizeTime(filter.end_time)}`);
          if (isNaN(startTime) || isNaN(endTime)) {
            console.warn("Invalid date conversion:", filter);
            return false;
          }
          const startHours = startTime.getHours();
          const startMinutes = startTime.getMinutes();
          const endHours = endTime.getHours();
          const endMinutes = endTime.getMinutes();
          const isAfterStartTime = currentHours > startHours || currentHours === startHours && currentMinutes >= startMinutes;
          const isBeforeEndTime = currentHours < endHours || currentHours === endHours && currentMinutes <= endMinutes;
          return isAfterStartTime && isBeforeEndTime;
        });
        if (firstMatchingFilter) {
          setSelectedFilters([firstMatchingFilter]);
        } else {
          setSelectedFilters(["tudo"]);
        }
      };

      // Check if dateFilter is today
      const selectedDate = new Date(dateFilter);
      const today = new Date();
      const isToday = selectedDate.getFullYear() === today.getFullYear() && selectedDate.getMonth() === today.getMonth() && selectedDate.getDate() === today.getDate();
      if (!isToday) {
        // Add "tudo" if it's not today
        setSelectedFilters(["tudo"]);
        return; // Skip interval if not today
      }

      // Run for today
      checkAndSetFilters();
      const intervalId = setInterval(checkAndSetFilters, 30 * 60 * 1000);
      return () => clearInterval(intervalId);
    }
  }, [fetchedFilters, dateFilter]);
  useEffect(() => {
    setPlaceFilter(updatedZones);
  }, [updatedZones]);
  const handleCustomFilterChange = (value, filterName) => {
    if (filterName === "status") setStatusFilter(value);
  };
  const getStatusColor = status => {
    switch (status) {
      case "accepted":
        return "green";
      case "Cancelled":
        return "red";
      case "pending_restaurant":
        return "yellow";
      case "edited":
        return "purple";
      default:
        return "black";
    }
  };
  const handleResetAttendance = () => {
    dispatch(resetAttendance());
    setShowNoTablesMessage(!showNoTablesMessage);
  };
  const handleShowModal = value => {
    if (value) {
      setSelectedReservation(value);
      setTokens(value);
      setCanceltMultipleReservations(false);
    } else {
      setCanceltMultipleReservations(true);
    }
    setShowModal(true);
  };
  const handleAccept = () => {
    if (acceptMultipleReservations) {
      dispatch(postReservationAccept(selectedMultipleReservations, true));
      setSelectedMultipleReservations([]);
    } else {
      dispatch(postReservationAccept(selectedReservation, false));
    }
    setShowAcceptModal(false);
  };
  const handleShowAcceptModal = value => {
    if (value) {
      setSelectedReservation(value);
      setAcceptMultipleReservations(false);
    } else {
      const tokensToExclude = new Set(theReservations.filter(rt => rt.status === "accepted" || rt.status === "Cancelled").map(rt => rt.token));
      const newSelectedMultipleReservations = selectedMultipleReservations.filter(token => !tokensToExclude.has(token));
      setSelectedMultipleReservations(newSelectedMultipleReservations);
      setAcceptMultipleReservations(true);
    }
    setShowAcceptModal(true);
  };
  const handleCloseAcceptModal = () => {
    setShowAcceptModal(false);
  };
  const handleModalClose = () => {
    setShowModal(false);
  };
  const handleCloseDateModal = () => {
    setShowDateModal(false);
  };
  const handleOpenDateModal = () => {
    setShowDateModal(true);
    dispatch(getReservationSums(restaurants?.id, dateFilter));
  };
  const handleCloseFilterModal = () => {
    setShowFilterModal(false);
  };
  const handleOpenFilterModal = () => {
    setShowFilterModal(true);
  };
  const handleModalSave = (selectedTables, token, ids) => {
    const fullTableInfo = getTableInfo(selectedTables, tables);
    dispatch(changeTables(token, fullTableInfo, ids));
    setShowTablesModal(false);
  };
  const handleOpenCreateReservationModal = (isReservationRetry = false) => {
    setReservationRetry(isReservationRetry);
    setIsReservationModalOpen(true);
    setReservation_or_waiting_list("reservation");
    setReset(!reset);
    setIsCreatingReservation(true);
    setTokens("");
  };
  const handleOpenEditReservationModal = tokeni => {
    setIsReservationModalOpen(true);
    setIsCreatingReservation(false);
    setReservation_or_waiting_list("reservation");
    setTokens(tokeni);
  };
  const handleCloseReservationModal = () => {
    setIsReservationModalOpen(false);
    setTokens();
  };
  const handleChange = event => {
    setSearchTerm(event.target.value);
    setHasSelectedSuggestion(false);
    setIsSugestionActive(false);
  };
  const cleanSearchTerm = event => {
    if (isSugestionActive) {
      setIsSugestionActive(false);
      setSearchTerm("");
    }
  };
  useEffect(() => {}, [hasSelectedSuggestion]);
  const handleSelectMultipleReservations = value => {
    setSelectedMultipleReservations(prevSelected => {
      if (prevSelected.includes(value)) {
        return prevSelected.filter(token => token !== value);
      } else {
        return [...prevSelected, value];
      }
    });
  };
  const handleSelectMultipleReservationsAll = reservationsList => {
    // Filter out reservations with status of "Cancelled"
    const filteredReservationsList = reservationsList.filter(r => r.status !== "Cancelled");

    // Check if all tokens in filteredReservationsList are already in selectedMultipleReservations
    const allTokensPresent = filteredReservationsList.every(r => selectedMultipleReservations.includes(r.token));
    if (allTokensPresent) {
      // If all tokens are already present, remove them
      const newSelectedMultipleReservations = selectedMultipleReservations.filter(token => !filteredReservationsList.some(r => r.token === token));
      setSelectedMultipleReservations(newSelectedMultipleReservations);
    } else {
      // Otherwise, add all tokens that are not already present
      const newTokens = filteredReservationsList.filter(r => !selectedMultipleReservations.includes(r.token)).map(r => r.token);
      setSelectedMultipleReservations([...selectedMultipleReservations, ...newTokens]);
    }
  };
  const handleSelectFilters = newSelectedItems => {
    setSelectedFilters(newSelectedItems);
    lastManualUpdate.current = new Date().getTime();
  };
  const handleCustomSelectPlaceOfTable = newSelectedItems => {
    setPlaceFilter(newSelectedItems);
  };
  const handleSelectStatuses = items => {
    setSelectedStatus(items);
  };
  const handleCheckCancel = token => {
    dispatch(checkCancelAction(token));
  };
  const updateSearchResultsTableNumber = (id, newTableNumber, status) => {
    setSearchResults(prevResults => {
      // Find the item with the matching ID
      const foundItem = prevResults.find(item => item.id === id);
      if (foundItem) {
        // Create a new array with the updated object
        return prevResults.map(item => item.id === id ? {
          ...item,
          table_number: newTableNumber,
          status: status
        } : item);
      } else {
        // Handle the case where the item with the given ID is not found
        console.error("Invalid ID. Unable to update search results.");
        return prevResults;
      }
    });
  };
  const handleSetPhoneNumber = (country_code, phone_number, reservationID, isPhoneConfirmed, the_customer_name, reservation_token) => {
    const countryCode = country_code;
    const phoneNumber = phone_number;
    const countryCodeLength = countryCode.length;
    const formattedPhoneNumber = phoneNumber.startsWith(countryCode) ? countryCode + " " + phoneNumber.slice(countryCodeLength) : phoneNumber;
    setCompletePhone(formattedPhoneNumber);
    setShowPhoneModal(!showPhoneModal);
    setCurrent_reservation_id(reservationID);
    setPhoneIsConfirmed(isPhoneConfirmed);
    setCustomer_name(the_customer_name);
    setReservationTokenToPhoneLink(reservation_token);
  };
  const showCustomerInfo = (country_code, phone_number) => {
    const countryCode = country_code;
    const phoneNumber = phone_number;
    const countryCodeLength = countryCode.length;
    const formattedPhoneNumber = phoneNumber.startsWith(countryCode) ? countryCode + " " + phoneNumber.slice(countryCodeLength) : phoneNumber;
    setCompletePhone(phone_number);
    setIsShowCustomerInfoModalActive(true);
  };

  // This function is called when a new message is received from the WebSocket
  const handleReservationUpdate = newReservation => {
    setAtTheDoorReservations(prev => {
      const isWaiting = newReservation.status === "waiting_list";
      const exists = prev.some(res => res.token === newReservation.token);

      // If it is NOT waiting_list anymore, remove it if it was there
      if (!isWaiting) {
        return prev.filter(res => res.token !== newReservation.token);
      }

      // If it IS waiting_list, keep it there (add or update)
      if (exists) {
        return prev.map(res => res.token === newReservation.token ? {
          ...res,
          ...newReservation
        } : res);
      }
      return [newReservation, ...prev];
    });
    setTheReservations(currentResults => {
      const index = currentResults.findIndex(res => res.token === newReservation.token);
      let updatedResults = [...currentResults];

      // Convert both dates to Date objects
      const newReservationDate = new Date(newReservation.date);
      const filterDate = new Date(dateFilterRef.current);
      if (index !== -1) {
        // If reservation exists, update it
        // Compare the year, month, and day parts of the dates
        if (newReservationDate.getFullYear() === filterDate.getFullYear() && newReservationDate.getMonth() === filterDate.getMonth() && newReservationDate.getDate() === filterDate.getDate()) {
          // If reservation exist and dates match, update newReservation
          updatedResults[index] = newReservation;
        } else {
          // else remove it
          updatedResults = updatedResults.filter(reservation => {
            return reservation.token !== newReservation.token;
          });
        }
      } else {
        // Compare the year, month, and day parts of the dates
        if (newReservationDate.getFullYear() === filterDate.getFullYear() && newReservationDate.getMonth() === filterDate.getMonth() && newReservationDate.getDate() === filterDate.getDate()) {
          // If reservation doesn't exist and dates match, add newReservation
          updatedResults.push(newReservation);
        }
        // If dates don't match, do not add newReservation
      }
      return updatedResults;
    });
    setAll_reservations(currentResults => {
      const index = currentResults.findIndex(res => res.token === newReservation.token);
      let updatedResults = [...currentResults];
      if (index !== -1) {
        // If reservation exists, update it
        updatedResults[index] = newReservation;
      } else {
        // If reservation doesn't exist, add it
        updatedResults.push(newReservation);
      }

      // Sort the updated results based on your criteria (e.g., date)
      updatedResults.sort((a, b) => new Date(a.date) - new Date(b.date));
      return updatedResults;
    });
    setReservationsWithChatMessages(current => {
      // Create a minimal reservation object with only the expected fields
      const normalizedUpdate = {
        id: newReservation.id,
        full_name: newReservation.full_name,
        email: newReservation.email,
        phone_number: newReservation.phone_number,
        date: newReservation.date,
        time: newReservation.time,
        number_of_people: newReservation.number_of_people,
        status: newReservation.status,
        last_chat_message: newReservation.last_chat_message,
        last_chat_sender: newReservation.last_chat_sender,
        chat_has_messages: newReservation.chat_has_messages,
        token: newReservation.token,
        chat_notification_restaurant: newReservation.chat_notification_restaurant,
        chat_notification_restaurant_all: newReservation.chat_notification_restaurant_all
      };
      const index = current.findIndex(res => res.token === normalizedUpdate.token);
      let updatedList = [...current];
      if (index !== -1) {
        // Update existing reservation while preserving any additional fields
        updatedList[index] = {
          ...updatedList[index],
          ...normalizedUpdate
        };

        // Remove from list if it no longer has chat messages
        if (!normalizedUpdate.chat_has_messages) {
          updatedList = updatedList.filter(res => res.token !== normalizedUpdate.token);
        }
      } else if (normalizedUpdate.chat_has_messages) {
        // Only add new reservations with chat messages
        updatedList.unshift(normalizedUpdate); // Add to beginning to maintain reverse chronological order
      }

      // Sort by ID descending (newest first) and limit to 50
      return updatedList.sort((a, b) => b.id - a.id).slice(0, 50);
    });
  };
  const socketRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const shouldReconnectRef = useRef(true);
  const [websocketStatus, setWebsocketStatus] = useState("connecting");
  const showConnectionOverlay = !onlineStatus;
  useEffect(() => {
    if (!restaurants?.id) return;
    const websocketBaseURL = process.env.REACT_APP_WEBSOCKET_URL;
    shouldReconnectRef.current = true;
    const clearReconnectTimeout = () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
        reconnectTimeoutRef.current = null;
      }
    };
    const connectWebSocket = () => {
      if (!shouldReconnectRef.current) return;
      if (socketRef.current && (socketRef.current.readyState === WebSocket.OPEN || socketRef.current.readyState === WebSocket.CONNECTING)) {
        return;
      }
      setWebsocketStatus(prev => prev === "connected" ? "reconnecting" : "connecting");
      const ws = new WebSocket(`${websocketBaseURL}reser/${restaurants.id}/`);
      socketRef.current = ws;
      ws.onopen = async () => {
        clearReconnectTimeout();
        setWebsocketStatus("connected");
        try {
          await dispatch_reservation_wait();
        } catch (e) {
          console.error("Failed to refresh reservations after WS connect:", e);
        }
      };
      ws.onmessage = event => {
        const data = JSON.parse(event.data);
        if (data.type === "reservation_update") {
          handleReservationUpdate(data.data);
        }
        if (data.type === "reservation_layout_update") {
          setReservationLayoutSocketUpdate({
            ...data.data,
            receivedAt: Date.now()
          });
        }
      };
      ws.onclose = event => {
        if (socketRef.current === ws) {
          socketRef.current = null;
        }
        if (!shouldReconnectRef.current) return;
        setWebsocketStatus("disconnected");
        clearReconnectTimeout();
        reconnectTimeoutRef.current = setTimeout(() => {
          connectWebSocket();
        }, 1500);
      };
      ws.onerror = error => {
        console.error("WebSocket error:", error);
        try {
          ws.close();
        } catch (e) {
          console.error("Failed to close WebSocket:", e);
        }
      };
    };
    connectWebSocket();
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        connectWebSocket();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      shouldReconnectRef.current = false;
      clearReconnectTimeout();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      if (socketRef.current) {
        const ws = socketRef.current;
        socketRef.current = null;
        ws.close(1000, "Component unmount");
      }
    };
  }, [restaurants?.id]);
  useEffect(() => {
    if (!restaurants?.id) return;
    if (websocketStatus === "connected") return;
    const interval = setInterval(() => {
      dispatch_reservation_wait();
    }, 7000);
    return () => clearInterval(interval);
  }, [restaurants?.id, websocketStatus]);
  useEffect(() => {
    const checkReservations = () => {
      if (restaurants) {
        const currentTime = moment.tz(restaurants.timezone);
        if (!currentTime.isValid()) {
          console.error("Failed to compute valid time for timezone: Europe/London");
          // Consider a fallback or notify users/administrators as appropriate
        }
        const currentTimeToShowAttendance = currentTime.clone().add(24, "hours");
        const currentTimeAfter = currentTime.clone().subtract(15, "minutes");
        console.log("currentTimeAfter: ", currentTimeAfter, " --- ", "currentTimeToShowAttendance: ", currentTimeToShowAttendance);
        theReservations.forEach((reservation, index) => {
          const reservationDateTime = moment.tz(`${reservation.date} ${reservation.time}`, "YYYY-MM-DD HH:mm", restaurants.timezone);
          if (reservationDateTime.isBefore(currentTimeAfter.format()) && reservation.status === "accepted") {
            dispatch(updateReservation(reservation.id, {
              status: "late"
            }, true));
          } else {}
        });
      }
    };
    const intervalId = setInterval(checkReservations, 5000); // 60000 is a minute

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [theReservations, restaurants]);
  useEffect(() => {
    if (restaurants) {
      const now = moment.tz(restaurants.timezone);
    }
    const londonTime = moment.tz("Europe/London");
  }, [restaurants]);
  const calculateTotalSeats = tablesUsed => {
    let totalSeats = 0;

    // Convert tablesUsed (string of table numbers) into an array of integers
    const tableNumbers = tablesUsed.split(",") // Split the string by commas
    .map(tableNumber => parseInt(tableNumber.trim(), 10)) // Convert each to integer
    .filter(tableNumber => !Number.isNaN(tableNumber)); // Filter out invalid numbers

    // Retrieve the configurations for each item
    const configValues = Object.values(connectTablesConfig);

    // Define a counter to keep track of the table connections
    let tableConnectionIndex = 0;

    // Iterate through each table number and find the matching table object
    if (all_tables) {
      tableNumbers.forEach((tableNumber, index) => {
        // Find the corresponding table object in all_tables based on table ID
        const tableObj = all_tables.find(table => table.id === tableNumber);
        if (!tableObj) {
          console.warn(`Table with ID ${tableNumber} not found in all_tables`);
          return; // Skip if table object is not found
        }

        // Extract and convert the number of seats to an integer
        const numberOfSeats = parseInt(tableObj.number_of_seats, 10);
        if (Number.isNaN(numberOfSeats)) {
          console.warn(`Invalid number_of_seats for table ID ${tableNumber}`);
          return; // Skip if number_of_seats is not a valid number
        }

        // Determine the configuration index based on the connection logic:
        // 1st config for 2 tables, 2nd config for 3 tables, 3rd config for 4 tables,
        // and then cycle between 2nd and 3rd configs thereafter.
        let configIndex;
        if (tableConnectionIndex === 0) {
          configIndex = 0; // Use the first config for the initial connection
        } else {
          configIndex = tableConnectionIndex % 2 + 1; // Alternate between 2nd and 3rd items
        }

        // Retrieve the configuration for the current table connection
        const config = configValues[configIndex];

        // Adjust the number of seats based on the configuration logic
        const adjustedSeats = numberOfSeats + (parseInt(config?.number_of_chairs, 10) || 0);

        // Add the adjusted number of seats to the total count
        totalSeats += adjustedSeats;

        // Increment the table connection index after processing the table
        tableConnectionIndex++;
      });
    }
    return totalSeats;
  };
  const UpdatePhoneNumber = () => {
    dispatch(postPhoneOrEmailConfirmation(current_reservation_id, "phone"));
  };
  const handleIsSuggestion = e => {
    setSearchTerm(e.target.value);
    setHasSelectedSuggestion(false);
  };
  const handleToReservation = () => {
    setDateFilter(reservation_created.date); // example 2025-06-27
    handleOpenEditReservationModal(reservation_created.token);
  };
  const handleRetryReservation = () => {
    handleOpenCreateReservationModal(true);
  };
  const handleReservationSuccessOrErrorReset = () => {
    dispatch(createReservationSuccessErrorReset());
  };
  const filtersBlock = <FiltersBlockShell ref={topContainerRef} $floorMode={isFloorView}>
      <FiltersHeaderRow $floorMode={isFloorView}>
        <FiltersTitle>{t("ui.screens.reservationFromRestaurantScreen.filtros")}</FiltersTitle>

        <FiltersHeaderActions>
          {!isAllReservations && <DateButton onClick={handleOpenDateModal}>
              <DateButtonLeft>
                <CalendarSvgIcon width={20} height={20} strokeColor={"#FAF6E9"} style={{
              marginLeft: "4px",
              marginRight: "4px"
            }} />
              </DateButtonLeft>

              <DateButtonRight>
                <DefaultDate date={dateFilter} />
              </DateButtonRight>
            </DateButton>}
        </FiltersHeaderActions>
      </FiltersHeaderRow>

      {!isAllReservations && <PlanLockedFilters $locked={areReservationFiltersBlocked} onClickCapture={handleLockedFiltersClick}>
          <FiltersMainRow>
            <FiltersControlsColumn>
              <FilterControlLine>
                <FilterControlIcon>
                  <div onClick={() => setIsOpenTimeFilters(!isOpenTimeFilters)}>
                    <ClockSvgIcon width={20} height={20} strokeColor={"#FAF6E9"} style={{
                  cursor: "pointer"
                }} />
                  </div>
                </FilterControlIcon>

                <FilterControlContent>
                  <FiltersComponent restaurantId={restaurants?.id} isOpen={isOpenTimeFilters} setIsOpen={setIsOpenTimeFilters} />

                  <CustomSelectArrayOfObjects items={fetchedFilters} onSelectChange={handleSelectFilters} selectedItems={selectedFilters} />
                </FilterControlContent>
              </FilterControlLine>

              <FilterControlLine>
                <FilterControlIcon>
                  <ZoneSvgIcon width={20} height={20} strokeColor={"#FAF6E9"} />
                </FilterControlIcon>

                <FilterControlContent>
                  <CustomSelectArray items={updatedZones} onSelectChange={handleCustomSelectPlaceOfTable} selectedItems={placeFilter} />
                </FilterControlContent>
              </FilterControlLine>
            </FiltersControlsColumn>

            <FiltersStatusBlock>
              <IconColorButtonTopRight>
                <IconColorVariationButton selectedVariation={selectedIconColorVariation} setSelectedVariation={setSelectedIconColorVariation} />
              </IconColorButtonTopRight>

              <SelectableStatusOptions onSelectChange={handleSelectStatuses} selectedItems={selectedStatus} reservations={sortedResultsAllStatus} />
            </FiltersStatusBlock>
          </FiltersMainRow>
        </PlanLockedFilters>}

      <FilterSearchSortRow>
        <PlanLockedControl locked={areReservationFiltersBlocked} onLockedClick={handleLockedSearchClick} label={t("ui.screens.reservationFromRestaurantScreen.atualizarPlanoParaPesquisarReservas")}>
          <SearchInline>
            <SearchBarLeft>
              <FontAwesomeIcon icon={faSearch} style={{
              color: "#FAF6E9"
            }} />
            </SearchBarLeft>

            <SearchBar ref={searchRef}>
              <SearchInput active={isSugestionActive} type="text" placeholder={t("ui.screens.reservationFromRestaurantScreen.procurar")} value={searchTerm} onChange={handleChange} onClick={e => cleanSearchTerm(e)} />

              {searchTerm && <FontAwesomeIcon icon={faCircleXmark} onClick={() => {
              setSearchTerm("");
              setHasSelectedSuggestion(false);
            }} style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#EE754C",
              cursor: "pointer",
              fontSize: "18px"
            }} />}

              {searchTerm && searchResults.length > 0 && !hasSelectedSuggestion && <SuggestionBox>
                    {searchResults.slice(0, 4).map(res => <SuggestionItem key={res.id} onClick={() => {
                setSearchTerm(res.full_name);
                setHasSelectedSuggestion(true);
                setIsSugestionActive(true);
              }}>
                        {res.full_name + " " + res.phone_number}
                      </SuggestionItem>)}
                  </SuggestionBox>}
            </SearchBar>
          </SearchInline>
        </PlanLockedControl>

        <PlanLockedControl locked={areReservationFiltersBlocked} onLockedClick={handleLockedSortingClick} label={t("ui.screens.reservationFromRestaurantScreen.atualizarPlanoParaOrdenarReservas")}>
          <DropdownSortItems options={["Horário", "Grupos maiores", "Grupos menores", "A - Z"]} handleOptionChange={setDropDownFilterButton} initialOption={dropDownFilterButton} />
        </PlanLockedControl>
      </FilterSearchSortRow>
    </FiltersBlockShell>;
  const floorFiltersBlock = <FloorFiltersBlockShell>
      <FloorFiltersHeaderRow>
        <FloorFiltersTitle>{t("ui.screens.reservationFromRestaurantScreen.filtros2")}</FloorFiltersTitle>

        <FloorFiltersHeaderActions>
          {!isAllReservations && <DateButton onClick={handleOpenDateModal}>
              <DateButtonLeft>
                <CalendarSvgIcon width={20} height={20} strokeColor={"#FAF6E9"} style={{
              marginLeft: "4px",
              marginRight: "4px"
            }} />
              </DateButtonLeft>

              <DateButtonRight>
                <DefaultDate date={dateFilter} />
              </DateButtonRight>
            </DateButton>}
        </FloorFiltersHeaderActions>
      </FloorFiltersHeaderRow>

      {!isAllReservations && <PlanLockedFilters $locked={areReservationFiltersBlocked} onClickCapture={handleLockedFiltersClick}>
          <FloorFiltersStatusBlock>
            <SelectableStatusOptions onSelectChange={handleSelectStatuses} selectedItems={selectedStatus} reservations={sortedResultsAllStatus} />
          </FloorFiltersStatusBlock>

          <FloorFilterControlLine>
            <FloorFilterControlIcon>
              <div onClick={() => setIsOpenTimeFilters(!isOpenTimeFilters)}>
                <ClockSvgIcon width={20} height={20} strokeColor={"#FAF6E9"} style={{
              cursor: "pointer"
            }} />
              </div>
            </FloorFilterControlIcon>

            <FloorFilterControlContent>
              <FiltersComponent restaurantId={restaurants?.id} isOpen={isOpenTimeFilters} setIsOpen={setIsOpenTimeFilters} />

              <CustomSelectArrayOfObjects items={fetchedFilters} onSelectChange={handleSelectFilters} selectedItems={selectedFilters} />
            </FloorFilterControlContent>
          </FloorFilterControlLine>

          <FloorFilterControlLine>
            <FloorFilterControlIcon>
              <ZoneSvgIcon width={20} height={20} strokeColor={"#FAF6E9"} />
            </FloorFilterControlIcon>

            <FloorFilterControlContent>
              <CustomSelectArray items={updatedZones} onSelectChange={handleCustomSelectPlaceOfTable} selectedItems={placeFilter} />
            </FloorFilterControlContent>
          </FloorFilterControlLine>
        </PlanLockedFilters>}

      <FloorFilterSearchSortRow>
        <PlanLockedControl locked={areReservationFiltersBlocked} onLockedClick={handleLockedSearchClick} label={t("ui.screens.reservationFromRestaurantScreen.atualizarPlanoParaPesquisarReservas2")}>
          <FloorSearchInline>
            <FloorSearchBarLeft>
              <FontAwesomeIcon icon={faSearch} style={{
              color: "#FAF6E9"
            }} />
            </FloorSearchBarLeft>

            <FloorSearchBar ref={searchRef}>
              <SearchInput active={isSugestionActive} type="text" placeholder={t("ui.screens.reservationFromRestaurantScreen.procurar2")} value={searchTerm} onChange={handleChange} onClick={e => cleanSearchTerm(e)} />

              {searchTerm && <FontAwesomeIcon icon={faCircleXmark} onClick={() => {
              setSearchTerm("");
              setHasSelectedSuggestion(false);
            }} style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              color: "#EE754C",
              cursor: "pointer",
              fontSize: "18px"
            }} />}

              {searchTerm && searchResults.length > 0 && !hasSelectedSuggestion && <SuggestionBox>
                    {searchResults.slice(0, 4).map(res => <SuggestionItem key={res.id} onClick={() => {
                setSearchTerm(res.full_name);
                setHasSelectedSuggestion(true);
                setIsSugestionActive(true);
              }}>
                        {res.full_name + " " + res.phone_number}
                      </SuggestionItem>)}
                  </SuggestionBox>}
            </FloorSearchBar>
          </FloorSearchInline>
        </PlanLockedControl>

        <PlanLockedControl locked={areReservationFiltersBlocked} onLockedClick={handleLockedSortingClick} label={t("ui.screens.reservationFromRestaurantScreen.atualizarPlanoParaOrdenarReservas2")}>
          <DropdownSortItems options={["Horário", "Grupos maiores", "Grupos menores", "A - Z"]} handleOptionChange={setDropDownFilterButton} initialOption={dropDownFilterButton} isRadius={false} />
        </PlanLockedControl>
      </FloorFilterSearchSortRow>
    </FloorFiltersBlockShell>;
  return <Container>
      {activateLoader || isCheckCancelLoading || isLoadingCancel ? <LoaderComponent activate={activateLoader} theSize={"o"} /> : showConnectionOverlay && onlineStatus && <ScreenNoConectionError isError={true} />}

      <PageTitleBar>
        <PageTitleText>{t("ui.screens.reservationFromRestaurantScreen.reservas")}</PageTitleText>

        <PageTitleActions>
          <HeaderCreateReservationButton type="button" onClick={() => {
          handleOpenCreateReservationModal(false);
        }} $is_production={is_production}>{t("ui.screens.reservationFromRestaurantScreen.reserva")}<FontAwesomeIcon icon={faPlus} />
          </HeaderCreateReservationButton>

          {!is_production && <HeaderViewSwitcher>
              <ReservationViewButton type="button" active={reservationViewMode === "cards"} onClick={() => setReservationViewMode("cards")} title={t("ui.screens.reservationFromRestaurantScreen.verReservasEmLista")} aria-label={t("ui.screens.reservationFromRestaurantScreen.verReservasEmLista2")}>
                <FontAwesomeIcon icon={faList} />
              </ReservationViewButton>

              <ReservationViewButton type="button" active={reservationViewMode === "floor"} onClick={() => setReservationViewMode("floor")} title={t("ui.screens.reservationFromRestaurantScreen.verPlantaDiaria")} aria-label={t("ui.screens.reservationFromRestaurantScreen.verPlantaDiaria2")}>
                <FontAwesomeIcon icon={faMap} />
              </ReservationViewButton>
            </HeaderViewSwitcher>}
        </PageTitleActions>
      </PageTitleBar>

      <ContentCenter $floorMode={isFloorView}>
        <Row>
          <Col sm={12} md={12} xl={12}>
            {(isLoading || websocketStatus === "disconected") && <LoaderComponent activate={isLoading} theSize={"o"} />}

            {!isFloorView && filtersBlock}

            {/* <FilterButtonDropDown selectedOption={dropDownFilterButton} setSelectedOption={setDropDownFilterButton}></FilterButtonDropDown> */}
            {Array.isArray(theReservations) && Array.isArray(selectedMultipleReservations) && selectedMultipleReservations.length > 0 && <StyledCard>
                  <CardBottom>
                    <Row>
                      <Col xs={12} className="mb-2">
                        <Row>
                          <Col xs={4} style={{
                      fontSize: "16px",
                      color: "white"
                    }}>{t("ui.screens.reservationFromRestaurantScreen.tudo")}<StyledCheckbox className="form-check-input makeItGreen" id="getEmailCheck" onClick={() => handleSelectMultipleReservationsAll(theReservations)} checked={theReservations.filter(r => r.status !== "Cancelled").every(r => selectedMultipleReservations.includes(r.token))} style={{
                        marginTop: "6px",
                        marginLeft: "5px"
                      }} />
                          </Col>
                          <Col xs={8} className="d-flex justify-content-end" style={{
                      fontSize: "14px",
                      color: "white"
                    }}>{t("ui.screens.reservationFromRestaurantScreen.selecionadas")}{selectedMultipleReservations.length}{" "}
                            /{" "}
                            {theReservations.filter(r => r.status !== "Cancelled").length}
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={12}>
                        <FormCheck>
                          <div className="d-flex justify-content-end">
                            {theReservations.length > 0 && theReservations.some(rt => rt.status !== "accepted" && rt.status !== "Cancelled") && <Button onClick={() => handleShowAcceptModal(false)} style={{
                        backgroundColor: "#3de3d8",
                        color: "white"
                      }}>{t("ui.screens.reservationFromRestaurantScreen.aceitar")}{" "}
                                  <FontAwesomeIcon size="lg" icon={faSquareCheck} style={{
                          color: "#ffffff",
                          paddingLeft: "5px"
                        }} />
                                </Button>}
                            <Button onClick={() => handleShowModal(false)} style={{
                        backgroundColor: "#de6718",
                        color: "white",
                        marginLeft: "10px"
                      }}>{t("ui.screens.reservationFromRestaurantScreen.rejeitar")}{" "}
                              <FontAwesomeIcon size="lg" icon={faRectangleXmark} style={{
                          color: "#ffffff",
                          paddingLeft: "5px"
                        }} />
                            </Button>
                          </div>
                        </FormCheck>
                      </Col>
                    </Row>
                  </CardBottom>
                </StyledCard>}

            <ReservationViewContent ref={reservationViewContentRef}>
              {reservationViewMode === "floor" ? <FloorBoardContainer height={containerHeight}>
                  {restaurants?.id && sortedResults && all_tables ? <DailyFloorBoard reservations={sortedResults} floorReservations={reservations} allTables={all_tables} restaurantId={restaurants.id} restaurantTimezone={restaurants.timezone} dateFilter={dateFilter} workspaceHeight={containerHeight} leftControls={floorFiltersBlock} dispatch_reservation_wait={dispatch_reservation_wait} reservationLayoutSocketUpdate={reservationLayoutSocketUpdate} /> : <Loader />}
                </FloorBoardContainer> : <ReservationContainer ref={containerRef} style={{
              height: `${containerHeight}px`
            }}>
                  {sortedResults && sortedResults.length > 0 ? <ReservationCard reservations={sortedResults} reservations_complete={reservations} isReservationFromRestaurantScreen={true} dispatch_reservation_wait={dispatch_reservation_wait} /> : sortedResults && sortedResults.length === 0 ? <p>{t("ui.screens.reservationFromRestaurantScreen.semNovasReservas")}</p> : <p>{t("ui.screens.reservationFromRestaurantScreen.erroReinicializarPagina")}</p>}
                </ReservationContainer>}
            </ReservationViewContent>
            <Modal show={showPhoneModal} onHide={() => setShowPhoneModal(!showPhoneModal)}>
              <Modal.Header>{t("ui.screens.reservationFromRestaurantScreen.telefonarParaCliente")}</Modal.Header>
              <Modal.Body>
                {customer_name}{" "}
                <div style={{
                fontSize: "20px"
              }}>
                  {completePhone.length > 4 ? <>
                      {"+" + completePhone.slice(0, 3) + " " + completePhone.slice(3)}
                      <SwitchLabelButton leftText="Não confirmado" rightText="Confirmado" onToggle={UpdatePhoneNumber} defaultState={phoneIsConfirmed} />
                    </> : "Sem número de telemóvel associado"}
                </div>
              </Modal.Body>
              <Modal.Footer>
                {completePhone.length > 4 ? <a href={`tel:${"+" + completePhone}`} style={{
                cursor: "pointer"
              }}>
                    <Button>{t("ui.screens.reservationFromRestaurantScreen.telefonar")}<FontAwesomeIcon size="lg" icon={faPhone} style={{
                    marginLeft: "7px"
                  }} />
                    </Button>
                  </a> : <Button style={{
                backgroundColor: "gray",
                border: "none"
              }}>{t("ui.screens.reservationFromRestaurantScreen.telefonar2")}<FontAwesomeIcon size="lg" icon={faPhoneSlash} style={{
                  marginLeft: "7px"
                }} />
                  </Button>}

                <Button onClick={() => handleOpenEditReservationModal(reservationTokenToPhoneLink)}>{t("ui.screens.reservationFromRestaurantScreen.editarNumeroDeTelemovel")}<FontAwesomeIcon size="lg" icon={faFilePen} style={{
                  marginLeft: "7px"
                }} />
                </Button>
                <Button style={{
                background: "#EE754C",
                border: "solid #EE754C 1px"
              }} onClick={() => setShowPhoneModal(!showPhoneModal)}>{t("ui.screens.reservationFromRestaurantScreen.cancelar")}<FontAwesomeIcon size="lg" icon={faXmark} style={{
                  marginLeft: "7px"
                }} />
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={showNoTablesMessage} onHide={() => setShowNoTablesMessage(!showNoTablesMessage)}>
              <Modal.Header closeButton>
                <Modal.Title>{t("ui.screens.reservationFromRestaurantScreen.atencaoReservaRestauradaSemMesasSuficientes")}</Modal.Title>
              </Modal.Header>
              <Modal.Footer>
                <Button variant="success" onClick={handleResetAttendance}>{t("ui.screens.reservationFromRestaurantScreen.ok")}</Button>
              </Modal.Footer>
            </Modal>

            {(selectedReservation || selectedMultipleReservations) && <>
                <Modal show={showAcceptModal} onHide={handleCloseAcceptModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>{t("ui.screens.reservationFromRestaurantScreen.aceitarReserva")}</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{t("ui.screens.reservationFromRestaurantScreen.aceitarSeguintesReservas")}<div className="acceptRejectModal">
                      {Array.isArray(theReservations) && acceptMultipleReservations ? <>
                          {theReservations.filter(rt => selectedMultipleReservations.includes(rt.token)).map((rt, index) => <div key={index}>
                                <p>
                                  {rt.full_name} / {rt.date} / {rt.time}
                                </p>
                              </div>)}
                        </> : <>
                          {Array.isArray(theReservations) && theReservations.filter(rt => tokens.includes(rt.token)).map((rt, index) => <div key={index}>
                                  <p>
                                    {rt.full_name} / {rt.date} / {rt.time}
                                  </p>
                                </div>)}
                        </>}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    {isLoadingAccept ? <Loader></Loader> : <SuccessButton variant="success" onClick={() => handleAccept()}>{t("ui.screens.reservationFromRestaurantScreen.sim")}</SuccessButton>}
                    <DangerButton variant="secondary" onClick={handleCloseAcceptModal}>{t("ui.screens.reservationFromRestaurantScreen.nao")}</DangerButton>
                  </Modal.Footer>
                </Modal>
              </>}
          </Col>
        </Row>
      </ContentCenter>
      {isReservationModalOpen && <CustomModal scrollable show={isReservationModalOpen} onHide={() => {
      if (reservationHasBeenModified) {
        setModalReservationModifyReservation(true);
      } else {
        setIsReservationModalOpen(false);
      }
    }} title={<>{isCreatingReservation ? "Nova reserva" : "Editar reserva"}</>} body={<>
              {isCreatingReservation && <div style={{
        marginBottom: "15px"
      }}>
                  <CustomSelect items={reservation_or_waiting_list_options} onSelectChange={setReservation_or_waiting_list} selectedItem={reservation_or_waiting_list} sub_lvl={restaurants?.sub_lvl} restaurant_id={restaurants?.id} />
                </div>}

              <ReservationScreen from_restaurant={true} creating={isCreatingReservation} setCreating={setIsCreatingReservation} isEditModalOpen={isReservationModalOpen} setIsEditModalOpen={setIsReservationModalOpen} restaurantId={restaurants?.id} handleCloseReservationModal={handleCloseReservationModal} token_from_restaurant={tokens} setTokens={setTokens} reset={reset} reservation_or_waiting_list={reservation_or_waiting_list} setReservationHasBeenModified={setReservationHasBeenModified} reservationHasBeenModified={reservationHasBeenModified} modalReservationModifyReservation={modalReservationModifyReservation} setModalReservationModifyReservation={setModalReservationModifyReservation} no_border={true} reservationRetry={reservationRetry} setReservationRetry={setReservationRetry} />
            </>}></CustomModal>}

      {showDateModal && <ConfirmationModal show={showDateModal} onHide={handleCloseDateModal} title={t("ui.screens.reservationFromRestaurantScreen.reservasDoMes")} body={<CustomDatePickerReservationSums handleTimeChange={value => setDateFilter(value)} handleCloseDateModal={handleCloseDateModal} date={dateFilter} restaurant_id={restaurants?.id} />} />}

      <CustomModal show={showFiltersUpgradeModal} onHide={() => setShowFiltersUpgradeModal(false)} title={t("ui.screens.reservationFromRestaurantScreen.filtrosDeReservas")} body={<p style={{
      margin: 0
    }}>{t("ui.screens.reservationFromRestaurantScreen.osFiltrosPorHorarioSalaE")}</p>} footer={<>
            <ModernButton color="#99b0ad" onClick={() => setShowFiltersUpgradeModal(false)}>{t("ui.screens.reservationFromRestaurantScreen.agoraNao")}</ModernButton>

            <ModernButton color="#ee754c" onClick={() => {
        setShowFiltersUpgradeModal(false);
        navigate(`/pick_plan_and_pay/${restaurants?.id}`);
      }}>{t("ui.screens.reservationFromRestaurantScreen.verPlanos")}</ModernButton>
          </>} />

      <CustomModal show={showSortingUpgradeModal} onHide={() => setShowSortingUpgradeModal(false)} title={t("ui.screens.reservationFromRestaurantScreen.ordenacaoDeReservas")} body={<p style={{
      margin: 0
    }}>{t("ui.screens.reservationFromRestaurantScreen.aOrdenacaoDeReservasPorHorario")}</p>} footer={<>
            <ModernButton color="#99b0ad" onClick={() => setShowSortingUpgradeModal(false)}>{t("ui.screens.reservationFromRestaurantScreen.agoraNao2")}</ModernButton>
            <ModernButton color="#ee754c" onClick={() => {
        setShowSortingUpgradeModal(false);
        navigate(`/pick_plan_and_pay/${restaurants?.id}`);
      }}>{t("ui.screens.reservationFromRestaurantScreen.verPlanos2")}</ModernButton>
          </>} />

      <CustomModal show={showSearchUpgradeModal} onHide={() => setShowSearchUpgradeModal(false)} title={t("ui.screens.reservationFromRestaurantScreen.pesquisaDeReservas")} body={<p style={{
      margin: 0
    }}>{t("ui.screens.reservationFromRestaurantScreen.aPesquisaDeReservasPorNome")}</p>} footer={<>
            <ModernButton color="#99b0ad" onClick={() => setShowSearchUpgradeModal(false)}>{t("ui.screens.reservationFromRestaurantScreen.agoraNao3")}</ModernButton>
            <ModernButton color="#ee754c" onClick={() => {
        setShowSearchUpgradeModal(false);
        navigate(`/pick_plan_and_pay/${restaurants?.id}`);
      }}>{t("ui.screens.reservationFromRestaurantScreen.verPlanos3")}</ModernButton>
          </>} />

      <NotificationBell restaurant_id={restaurants?.id} allReservations={all_reservations} reservations_past_estimated_time={reservations_past_estimated_time} reservationsWithChatMessages={reservationsWithChatMessages}></NotificationBell>

      <ConfirmationModal show={reservationErrorModal} // Modal is shown if reservationErrorModal is true
    onHide={() => {
      setReservationErrorModal(false); // Close modal
      handleReservationSuccessOrErrorReset();
    }} title={t("ui.screens.reservationFromRestaurantScreen.reservaNaoRegistada")} body={<>
            <FontAwesomeIcon icon={faCircleXmark} style={{
        color: "#D94B4B"
      }} />{" "}{t("ui.screens.reservationFromRestaurantScreen.erroAoCriarAReservaPor")}</>} cancelLabel="Fechar" confirmLabel="Tentar novamente" cancelColor="#99B0AD" confirmColor="#EE754C" onConfirm={() => {
      setReservationErrorModal(false); // Close success modal on error modal retry
      handleRetryReservation(); // Retry reservation
    }} />
      <ConfirmationModal show={reservationSuccessModal} onHide={() => {
      setReservationSuccessModal(false);
      handleReservationSuccessOrErrorReset();
    }} title={createdReservationWithoutTables ? "Reserva registada sem mesas" : "Reserva registada"} body={<>
            <FontAwesomeIcon icon={createdReservationWithoutTables ? faExclamationTriangle : faCircleCheck} style={{
        color: createdReservationWithoutTables ? "#d15823" : "#4CAE4C"
      }} />{" "}
            {createdReservationWithoutTables ? <>{t("ui.screens.reservationFromRestaurantScreen.aReservaFoiRegistadaComSucesso")}<br />
                <br />{t("ui.screens.reservationFromRestaurantScreen.podesAbrirAReservaParaAdicionar")}</> : <>{t("ui.screens.reservationFromRestaurantScreen.aReservaFoiRegistadaComSucesso2")}</>}
          </>} confirmLabel="OK" cancelLabel={createdReservationWithoutTables ? "Adicionar mesas" : "Editar reserva"} cancelColor="#99B0AD" confirmColor="#EE754C" onConfirm={() => {
      setReservationSuccessModal(false);
      handleReservationSuccessOrErrorReset();
    }} onCancel={() => {
      handleToReservation();
      setReservationSuccessModal(false);
      handleReservationSuccessOrErrorReset();
    }} />

      <ConfirmationModal show={showModalInternetConectionFailure && onlineStatus} // Modal is shown if reservationErrorModal is true
    onHide={() => {
      setShowModalInternetConectionFailure(false); // Close modal
    }} title={t("ui.screens.reservationFromRestaurantScreen.erroDeConexao")} body={<>
            <FontAwesomeIcon icon={faCircleXmark} style={{
        color: "#D94B4B"
      }} />{" "}{t("ui.screens.reservationFromRestaurantScreen.erroDeLigacaoPorFavorVerifique")}</>} confirmLabel={<>
            {" "}{t("ui.screens.reservationFromRestaurantScreen.atualizarPagina")}{" "}
            <FontAwesomeIcon icon={faRefresh} style={{
        color: "#ffffff",
        paddingTop: "4px",
        paddingLeft: "10px"
      }} />{" "}
          </>} confirmColor="#EE754C" onConfirm={() => {
      // Reload the page
      window.location.reload();
    }} />
    </Container>;

  // ...
}
export default ReservationFromRestaurantScreen;
